// extracted by mini-css-extract-plugin
export default {"button":"style_button__tzCAX","paypal":"style_paypal__yJ95w","default":"style_default__zIpFS"};